import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  locations: [],
  selectedLocation: null,
  error: null,
  isLoading: false,
};

export const fetchLocations = createAsyncThunk(
  "location/fetchLocations",
  async (payload, thunkAPI) => {
    const token = payload;
    const response = await axios
      .get("/restaurant/locations", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        return res.data.locations;
      })
      .catch((err) => {
        return thunkAPI.rejectWithValue(
          "Something went wrong! Please try again later"
        );
      });
    return response;
  }
);

export const locationsSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setSelectedLocation: (state, action) => {
      state.selectedLocation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLocations.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchLocations.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      if (action.payload.length === 0) {
        state.locations = [];
      } else {
        state.locations = action.payload;
      }
    });
    builder.addCase(fetchLocations.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { setSelectedLocation } = locationsSlice.actions;

export default locationsSlice.reducer;
